import { useCallback, useEffect, useRef } from "react";

const AttendancePopup = ({ title, message, isOpen, onClose, secondaryButtonText, onSecondaryClick }) => {
  const popupRef = useRef(null);

  // Handle Escape key to close popup
  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    },
    [onClose]
  );

  // Handle click outside to close popup
  const handleOverlayClick = useCallback(
    (event) => {
      if (event.target === event.currentTarget) {
        onClose();
      }
    },
    [onClose]
  );

  const handleSecondaryClick = useCallback(() => {
    if (onSecondaryClick) {
      onSecondaryClick();
    }
    onClose();
  }, [onSecondaryClick, onClose]);

  // Focus popup when it opens
  useEffect(() => {
    if (isOpen && popupRef.current) {
      popupRef.current.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto overscroll-contain py-4 px-2 sm:items-center sm:py-6"
      onClick={handleOverlayClick}
    >
      <div
        ref={popupRef}
        className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4 max-h-[min(90vh,calc(100dvh-2rem))] overflow-y-auto overscroll-contain min-w-0 my-auto"
        role="dialog"
        aria-labelledby="popup-title"
        aria-describedby="popup-message"
        tabIndex={-1}
        onKeyDown={handleKeyDown}
      >
        <h2 id="popup-title" className="text-lg font-bold text-gray-800 mb-4">
          {title}
        </h2>
        <p id="popup-message" className="text-gray-600 mb-6 break-words">
          {message}
        </p>
        <div className="flex flex-wrap justify-end gap-3">
          <button
            onClick={onClose}
            className="bg-[#674936] text-white px-4 py-2 rounded-lg hover:bg-[#8B5F3D] transition-colors duration-300 font-semibold"
          >
            OK
          </button>
          {secondaryButtonText && onSecondaryClick && (
            <button
              onClick={handleSecondaryClick}
              className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors duration-300 font-semibold"
            >
              {secondaryButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AttendancePopup;